import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

export const starVariants = cva("", {
  defaultVariants: {
    color: "default",
    variant: "full",
  },
  variants: {
    color: {
      default: "text-new-beginnings-base",
      gold: "",
      white: "text-white",
    },
    variant: {
      empty: "opacity-25",
      full: "",
    },
  },
});

export type StarVariantProps = VariantProps<typeof starVariants>;
